module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "North Falls statutory consultation",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--north-falls-stat.netlify.app' : 'https://stat.northfallsoffshore.com',
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? 'https://north-falls-stat-map.jfd-test.co.uk' : 'https://statmap.northfallsoffshore.com',

    base: {
        "contact_address": "",
        "contact_number": "",
        "contact_email": ""
    },

    holding: {
        "brand": "/assets/images/north-falls-brand.png",
    },

    meta: {
        "defaultSocialImage": "/assets/images/gg-wind-farm.jpg",
        "author": "North Falls statutory consultation",
        "description": "North Falls statutory consultation",
        "gtag": "G-C6R6NKL6NK",
        "gtm": "GTM-P9Z2SJN"
    },

    form: {
        "feedback": {
            "catcher_id": "",
            "honeypot": "",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b"
        }
    },

    consultation: {
        "feedback_active": false,
        "start_datetime": "Tuesday May 16 2023",
        "end_datetime": "Friday July 14 2023"
    },

    hasMap: true,

    // Bugsnag API Key
    bugsnagApiKey: "9aed801500196c487747620f0b466e6d",

    // Marker.io Key - replace this default key
	marker_io: "644bb8a4034fd79114a90875",
};
